import React, { useState, useEffect } from "react";
import { appendEllipsis } from "../../../../utils/helper";
import { fetcher, postsFetcher } from "../../../../utils/request";
import getEnvEndpoints from "../../../../utils/endpoints";
import PdfViewer from "../../../cards/common/PdfViewer";
import { getContentDetailsOnClick } from "../../../../utils/utility"

const TocContent = ({ post, book }) => {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pmbokContent, setPmbokContent] = useState({
    loaded: false,
    data: null,
  });

  useEffect(() => {
    if (expanded) {
      setExpanded(false);
      setPmbokContent({
        loaded: false,
        data: null,
      });
    }
  }, [post]);

  const toggleExpand = async () => {
    if (expanded) {
      if (document.getElementById(post?.id))
        document
          .getElementById(post?.id)
          .scrollIntoView({ behavior: "smooth" });
      setPmbokContent({
        loaded: false,
        data: null,
      });
    } else {
      setLoading(true);
      try {
        const contentItems = post?.attributionSources
          ? post
          : await fetcher(
            `/api/content/getContentItem?id=${post.id}&contentKey=${post.contentKey}`
          );
        if (
          !pmbokContent.loaded &&
          contentItems?.attributionSources.length !== 0
        ) {
          const id = contentItems?.attributionSources[0].link;
          if (!id.trim().length) return;
          const fragments = id.split(":");
          const data = await fetcher(`/api/pmbok/${book.book}/fragments/${fragments}`);
          await Promise.all(data.map(async fragment => {
            if (!fragment.fields.SubType) return;
            const bytes = await postsFetcher("/api/pmbok/pdf", null, {
              params: { uri: fragment.fields.Content || getEnvEndpoints().pmbok7TocUrl },
              responseType: "arraybuffer"
            });
            if (!bytes) throw new Error("Unable to retrieve PDF bytes.");
            fragment.fields.Content = { data: new Uint8Array(bytes) };
          }));
          setPmbokContent({ loaded: true, data });
        }
      } catch (error) {
        console.error("Unable to load PDF.", error);
      } finally {
        setLoading(false);
      }
    }
    setExpanded(!expanded);
  };

  const buttonClass =
    "bg-blue-700 rounded-lg py-3 px-3 text-center cursor-pointer";
  const buttonTextClass = "font-bold text-white text-xs lg:text-sm uppercase";

  return (
    <div>
      {expanded ? (
        <div
          className="relative overflow-hidden select-none"
          onContextMenu={(e) => e.preventDefault()}
        >
          {(pmbokContent.data &&
            pmbokContent.data.map((fragment) => {
              return (
                (!fragment?.fields.SubType && (
                  <div className="content-fragment" key={fragment?.id}>
                    <div
                      className="content-styling"
                      dangerouslySetInnerHTML={{
                        __html: fragment?.fields.Content,
                      }}
                    />
                  </div>
                )) || (
                  <PdfViewer
                    key={`pdf` + fragment?.id}
                    fragment={fragment}
                    fragmentZoom={1.0}
                  />
                )
              );
            })) || (
              <>
                <div className="content-fragment" key={post?.id}>
                  <div
                    className="content-styling"
                    dangerouslySetInnerHTML={{
                      __html: post?.fullContent,
                    }}
                  />
                </div>
              </>
            )}
        </div>
      ) : (
        <div
          className="text-base font-normal mb-2"
          dangerouslySetInnerHTML={{
            __html: post.description && appendEllipsis(post.description),
          }}
        />
      )}
      <div className="my-3 mx-auto" style={{ width: "120px" }} adoberegion="Toc-card-content">
        {expanded ? (
          <div className={buttonClass} onClick={() => { toggleExpand(); getContentDetailsOnClick(post, 'less', 'Toc-card-content') }}>
            <h5 className={buttonTextClass}>Less</h5>
          </div>
        ) : (
          <div className={buttonClass} onClick={() => { toggleExpand(); getContentDetailsOnClick(post, 'more', 'Toc-card-content') }}>
            <h5 className={buttonTextClass}>
              {loading && <i className="fas fa-spin fa-spinner mr-3" />}More
            </h5>
          </div>
        )}
      </div>
    </div>
  );
};

export default TocContent;
